import { render, staticRenderFns } from "./mululist.vue?vue&type=template&id=02573e2a&scoped=true"
import script from "./mululist.vue?vue&type=script&lang=js"
export * from "./mululist.vue?vue&type=script&lang=js"
import style0 from "./mululist.vue?vue&type=style&index=0&id=02573e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02573e2a",
  null
  
)

export default component.exports